import styled from 'styled-components'

export const StyledDiv = styled.div`
   {
    a {
      color: #2196f3;
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }
  }
`
